function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoundedNavigation = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _Button = require("../Button");
var _View = require("../View");
var Icons = _interopRequireWildcard(require("../Icons"));
var _SVG = require("../SVG");
var _reactNative = require("react-native-web");
var _styles = require("./styles");
var _useLang = require("./useLang");
var _reactI18next = require("react-i18next");
var _styles2 = require("../../styles");
var _reactNativeOutsidePress = _interopRequireDefault(require("react-native-outside-press"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["items", "style"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var RoundedNavigation = exports.RoundedNavigation = (0, _react.memo)(function (_ref) {
  var items = _ref.items,
    style = _ref.style,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useStyles = (0, _styles.useStyles)(),
    styles = _useStyles.styles,
    buttonHeight = _useStyles.buttonHeight;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    COLORS = _STYLES$useStyles.COLORS;
  var _itemsRef = (0, _react.useRef)([]);
  var _useState = (0, _react.useState)([]),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    _visibleItems = _useState2[0],
    _setVisibleItems = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    _isMoreMenuOpen = _useState4[0],
    _setIsMoreMenuOpen = _useState4[1];
  var _useState5 = (0, _react.useState)(true),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    _showMoreButton = _useState6[0],
    _setShowMoreButton = _useState6[1];
  var _useState7 = (0, _react.useState)(true),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    _isCheckingItems = _useState8[0],
    _setIsCheckingItems = _useState8[1];
  var _useState9 = (0, _react.useState)(),
    _useState10 = (0, _slicedToArray2["default"])(_useState9, 2),
    _moreMenuPosition = _useState10[0],
    _setMoreMenuPosition = _useState10[1];
  var _containerRef = (0, _react.useRef)(null);
  var _containerWidth = (0, _react.useRef)(0);
  var _moreButtonRef = (0, _react.useRef)(null);
  var _useState11 = (0, _react.useState)(null),
    _useState12 = (0, _slicedToArray2["default"])(_useState11, 2),
    _isPointerOver = _useState12[0],
    _setIsPointerOver = _useState12[1];
  var _checkVisibleItems = (0, _react.useCallback)(function () {
    if (items.length === 0 || !_itemsRef.current) return;
    var _tempVisibleItems = [];
    var _checkedItems = [];
    if (_itemsRef.current.length > 0 && _containerRef.current) {
      _setIsCheckingItems(true);
      var _loop = function _loop(i) {
        var _itemsRef$current$i;
        (_itemsRef$current$i = _itemsRef.current[i]) == null ? void 0 : _itemsRef$current$i.measureLayout(_containerRef.current, function (_, y) {
          _checkedItems.push(i);
          if (y < buttonHeight) {
            _tempVisibleItems.push(i);
          }
          if (_checkedItems.length === _itemsRef.current.length) {
            _setVisibleItems(_tempVisibleItems);
            _setShowMoreButton(_tempVisibleItems.length !== _itemsRef.current.length);
            _setIsCheckingItems(false);
          }
        }, function () {});
      };
      for (var i = 0; i < _itemsRef.current.length; i++) {
        _loop(i);
      }
    }
  }, [buttonHeight, items]);
  var _onLayout = function _onLayout(_ref2) {
    var width = _ref2.nativeEvent.layout.width;
    if (_containerWidth.current !== width) {
      _containerWidth.current = width;
      _checkVisibleItems();
    }
  };
  var _getMeasurements = function _getMeasurements() {
    var _containerRef$current;
    (_containerRef$current = _containerRef.current) == null ? void 0 : _containerRef$current.measure(function (_x, _y, width, _height, px) {
      if (width && px) {
        _setMoreMenuPosition({
          left: px,
          maxWidth: width
        });
      }
      _setIsMoreMenuOpen(true);
    });
  };
  var _onPressMoreButton = function _onPressMoreButton() {
    if (!_isMoreMenuOpen) {
      _getMeasurements();
    } else {
      _setIsMoreMenuOpen(false);
    }
  };
  var _hideMenu = function _hideMenu() {
    _setIsMoreMenuOpen(false);
    if (_reactNative.Platform.OS === 'web') {
      var _moreButtonRef$curren;
      (_moreButtonRef$curren = _moreButtonRef.current) == null ? void 0 : _moreButtonRef$curren.focus == null ? void 0 : _moreButtonRef$curren.focus();
    }
  };
  (0, _react.useEffect)(function () {
    var _dimensionEvent = _reactNative.Dimensions.addEventListener('change', _hideMenu);
    if (_reactNative.Platform.OS === 'web') {
      window.addEventListener('scroll', _hideMenu);
    }
    return function () {
      _dimensionEvent == null ? void 0 : _dimensionEvent.remove();
      if (_reactNative.Platform.OS === 'web') {
        window.removeEventListener('scroll', _hideMenu);
      }
    };
  }, []);
  if (!items || items.length === 0) return null;
  return (0, _jsxRuntime.jsxs)(_View.View, {
    style: [styles.container, style],
    onLayout: _onLayout,
    children: [(0, _jsxRuntime.jsxs)(_View.View, Object.assign({
      style: [styles.roundedNavigation, (_isCheckingItems || _showMoreButton) && styles.roundedNavigation_withmore, _isCheckingItems && {
        opacity: 0
      }],
      testID: "RoundedNavigation",
      ref: _containerRef
    }, props, {
      children: [items.map(function (item, index) {
        var _key = "RoundedNavigationItem-".concat(index);
        var _isVisible = _visibleItems.includes(index);
        if (!_isVisible && !_isCheckingItems) return null;
        return (0, _jsxRuntime.jsx)(_Button.Button, {
          type: _Button.ButtonType.blank,
          containerStyle: [styles.buttonStyleContainer, index !== 0 && styles.buttonStyleContainer_marginLeft],
          textStyle: [styles.buttonStyle, _isPointerOver === _key && styles.buttonStyle_pointerOver, item.active && styles.buttonStyle_active],
          containerRef: function containerRef(itemRef) {
            return _itemsRef.current[index] = itemRef;
          },
          href: item.href,
          onPointerEnter: function onPointerEnter() {
            return _setIsPointerOver(_key);
          },
          onPointerLeave: function onPointerLeave() {
            return _setIsPointerOver(null);
          },
          ariaLabel: item.label,
          children: (0, _jsxRuntime.jsx)(_reactNative.Text, {
            numberOfLines: 1,
            style: styles.buttonText,
            children: item.label
          })
        }, _key);
      }), _showMoreButton && (0, _jsxRuntime.jsx)(_Button.Button, {
        containerStyle: [styles.buttonStyleContainer, styles.buttonStyleContainer_moreButton],
        textStyle: [styles.buttonStyle, styles.buttonStyle_moreButton, _isPointerOver === 'moreButton' && styles.buttonStyle_pointerOver, _isMoreMenuOpen && styles.buttonStyle_active],
        ariaLabel: t('roundedNavigation:moreButtonLabel'),
        onPress: _onPressMoreButton,
        icon: Icons.MoreDots,
        iconContainerStyle: styles.iconContainer,
        iconStyle: styles.icon,
        type: _Button.ButtonType.blank,
        ref: _moreButtonRef,
        onPointerEnter: function onPointerEnter() {
          return _setIsPointerOver('moreButton');
        },
        onPointerLeave: function onPointerLeave() {
          return _setIsPointerOver(null);
        }
      })]
    })), !_isCheckingItems && _isMoreMenuOpen && (0, _jsxRuntime.jsx)(_reactNativeOutsidePress["default"], {
      onOutsidePress: _hideMenu,
      children: (0, _jsxRuntime.jsx)(_View.View, {
        style: [styles.roundedNavigationDropdownContainer, Object.assign({}, _moreMenuPosition)],
        children: (0, _jsxRuntime.jsxs)(_View.View, {
          style: styles.roundedNavigationDropdown,
          children: [(0, _jsxRuntime.jsx)(_SVG.SVG.Svg, {
            viewBox: "0 0 24 12",
            style: styles.roundedNavigationDropdownArrow,
            children: (0, _jsxRuntime.jsx)(_SVG.SVG.Polygon, {
              fill: COLORS.whisper,
              points: "12 0, 0 12, 24 12, 12 0"
            })
          }), items.filter(function (_, index) {
            return !_visibleItems.includes(index);
          }).map(function (item, index) {
            var _key = "RoundedNavigationMoreItem-".concat(index);
            return (0, _jsxRuntime.jsx)(_Button.Button, {
              testID: "RoundedNavigationMoreItem",
              type: _Button.ButtonType.blank,
              containerStyle: [styles.buttonStyleContainer, index !== 0 && styles.buttonStyleContainer_marginTop],
              textStyle: [styles.buttonStyle, styles.buttonStyle_moreMenu, _isPointerOver === _key && styles.buttonStyle_pointerOver, item.active && styles.buttonStyle_active],
              href: item.href,
              onPointerEnter: function onPointerEnter() {
                return _setIsPointerOver(_key);
              },
              onPointerLeave: function onPointerLeave() {
                return _setIsPointerOver(null);
              },
              ariaLabel: item.label,
              children: (0, _jsxRuntime.jsx)(_reactNative.Text, {
                numberOfLines: 1,
                style: styles.buttonText,
                children: item.label
              })
            }, _key);
          })]
        })
      })
    })]
  });
});